'use strict';

(function () {
    'use strict';

    angular.module('depa.choiceSlot', ['ui.router', 'common']);
})();